<template>
  <!-- "Apply to trading balance" switch — default OFF, amber when ON,
       disabled with the reason in a tooltip when the server says it's not possible. -->
  <span class="bk-bal no-click" :class="{ 'is-on': value, 'is-blocked': !allowed }"
        v-b-tooltip.hover.left="allowed ? (value ? $t('backup.balanceOnHint') : $t('backup.balanceOffHint')) : blockedReason">
    <b-form-checkbox switch class="no-click" :checked="value" :disabled="!allowed"
                     @change="v => $emit('input', v)">
      <span class="bk-bal__label">
        <i v-if="!allowed" class="fa-solid fa-lock"></i>
        {{ value ? $t('backup.balanceOn') : $t('backup.recordOnly') }}
      </span>
    </b-form-checkbox>
  </span>
</template>

<script>
export default {
  name: 'BackupBalanceSwitch',
  props: {
    value: { type: Boolean, default: false },
    allowed: { type: Boolean, default: false },
    blockedReason: { type: String, default: '' },
  },
}
</script>

<style scoped lang="scss">
.bk-bal {
  display: inline-flex; align-items: center; white-space: nowrap;
  padding: 0.1rem 0.5rem 0.1rem 0.35rem; border-radius: 999px;
  border: 1px solid rgba(110, 117, 159, 0.2);
  &__label { font-size: 0.74rem; font-weight: 700; color: #82868b; i { font-size: 0.65rem; margin-right: 0.15rem; } }
  &.is-on { background: rgba(255, 159, 67, 0.14); border-color: rgba(255, 159, 67, 0.6); }
  &.is-on .bk-bal__label { color: #e8862a; }
  &.is-blocked { opacity: 0.65; border-style: dashed; }
  ::v-deep .custom-control-input:checked ~ .custom-control-label::before { background-color: #ff9f43; border-color: #ff9f43; }
}
body.dark-layout .bk-bal { border-color: #3b4253; }
body.dark-layout .bk-bal.is-on { border-color: rgba(255, 159, 67, 0.6); }
</style>
